import React from 'react';
import { blur, Field, touch } from 'redux-form';
import { connect } from 'react-redux';

import { EMPLOYEE_PAY_FORM } from 'src/constants/FormNames';
import { toHourFormat, toFloatFormat, toDisplayFormat, toDbFormat } from 'src/utils/Completion';
import { isNumberFormat, isHourFormat } from 'src/utils/CustomValidators';

import AttendanceField from './AttendanceField';
import TimeFieldMockup from './TimeFieldMockup';

import styles from './EmployeePayForm.scss';

const allowanceItemValidate = unitType => {
  switch (unitType) {
    case 'time':
      return [isHourFormat];
    default:
      return [isNumberFormat];
  }
};

const allowanceItemFormat = (unitType, value) => {
  switch (unitType) {
    case 'time':
      return toHourFormat(value);
    default:
      return toFloatFormat(value);
  }
};

const AttendancesSectionMockup = ({ fields, isViewOnly, dispatch }) => (
  <tbody>
    {fields.map((field, index) => (
      <React.Fragment key={`ps.${index + 1}`}>
        <tr>
          <th>{field.label}</th>
          <td className={styles.value} style={{ textAlign: 'right' }}>
            {isViewOnly ? (
              <TimeFieldMockup title={field.label} value={field.value} toDisplayFormat={toDisplayFormat} />
            ) : (
              <Field
                name={field.name}
                component={AttendanceField}
                type="text"
                validate={allowanceItemValidate(field.unitType)}
                toDisplayFormat={toDisplayFormat}
                toDbFormat={toDbFormat}
                onBlur={(input, newValue, previousValue) => {
                  input.preventDefault();
                  dispatch(blur(EMPLOYEE_PAY_FORM, field.name, allowanceItemFormat(field.unitType, previousValue)));
                  dispatch(touch(EMPLOYEE_PAY_FORM, field.name));
                }}
              />
            )}
          </td>
        </tr>
      </React.Fragment>
    ))}
  </tbody>
);

export default connect()(AttendancesSectionMockup);
